import React, { Fragment } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

export const ThemeMultipleSelect = ({
  field,
  form: { setFieldValue, touched, errors },
  otherProps
}) => {
  const { creatable = false, ...restOtherProps } = otherProps;

  const SelectComponent = creatable ? Select.Creatable : Select;

  const hasError = !!(touched[field.name] && errors[field.name]);

  return (
    <Fragment>
      <SelectComponent
        multi
        value={field.value}
        menuPlacement='top'
        isValidNewOption={({ label }) => {
          if (!label) return false;
          return label.length > 1 || !(/[^a-z0-9]+/g.test(label));
        }}
        onChange={selectedOptions => {
          setFieldValue(field.name, selectedOptions);
        }}
        onBlur={field.onBlur}
        {...restOtherProps}
        error={touched[field.name] && errors[field.name]}
      />
      {hasError && (<ErrorMessage >{errors[field.name]}</ErrorMessage >)}
    </Fragment>
  );
};

const ErrorMessage = styled.small`
font-size: 0.8125rem;
  color: #e05173 !important;
  transition: all 0.2s ease-in-out 0s;
  animation: fadeIn 0.2s ease-in-out 0s 1 normal;
`;

export default ThemeMultipleSelect;



// WEBPACK FOOTER //
// ./src/components/forms/fields/themeMultipleSelect.js